<jhi-spinner *ngIf="loading"></jhi-spinner>
<jhi-alert></jhi-alert>
<div class="container">
  <div class="mt-4">
  <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a href="javascript:void(0)" (click)="goToHome()">Home</a><span class="separator">/</span></li>
      <li class="breadcrumb-item active"><a href="javascript:void(0)">Gestione preferiti</a></li>
    </ol>
  </nav>
  </div>
  <h3 class="fw-bold text-center mt-5 mb-3">Gestione Preferiti</h3>
  <div class="d-flex justify-content-end"><button class="btn btn-primary" (click)="openMdPreferiti()">Aggiorna dati da visure anagrafiche</button></div>
  <div class="d-flex justify-content-center mb-4">
    <div class="w-100 mb-3">
      <ng-container *ngFor="let sezione of tables">
        <ng-container *ngIf="sezione === 'allegato'">
          <div class="table-responsive" style="overflow-x: hidden">
            <table class="table table-striped my-4">
              <thead>
              <tr>
                <td colspan="6" class="text-start table-header">
                  <h5 class="fw-bold mb-0">Allegati</h5>
                </td>
                <td>
                  <div class="d-flex justify-content-end">
                  <div data-bs-toggle="modal" data-bs-target=".import-modal" (click)="getArrayAllegati().length === 10 ? '' : removeFile()" class="me-2">
                    <svg class="icon icon-sm icon-primary c-pointer">
                      <use href="./content/svg/sprites.svg#it-upload"></use>
                    </svg>
                  </div>
                  </div>
                </td>
              </tr>
              <td class="d-flex justify-content-start my-4" *ngIf="getArrayAllegati().length === 0">
                <h5 class="fw-bold mb-0">Non ci sono allegati.</h5>
              </td>
              <div class="modal fade import-modal" tabindex="-1" role="dialog" aria-labelledby="importModal"
                   aria-hidden="true">
                <div class="modal-dialog modal-lg">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h2 class="modal-title h5 " id="importModal">INSERISCI IL TUO FILE.</h2>
                      <button type="button" class="btn-close" data-bs-dismiss="modal"
                              aria-label="Chiudi finestra modale"></button>
                    </div>
                    <div class="modal-body">
                      <div class="form-group my-3">
                        <textarea class="text-area" maxlength="200" rows="5v " [(ngModel)]="fileDescription"
                                  placeholder="Inserisci una descrizione dell'allegato."></textarea>
                      </div>
                      <div
                        class="d-flex justify-content-end align-content-center align-items-center"
                        [class.dropzone]="windowSize > 960"
                        id="myDropzone"
                        (click)="openFileInput()"
                        (dragover)="onDragOver($event)"
                        (dragleave)="onDragLeave($event)"
                        (drop)="onDrop($event)"
                      >
                        <label class="dropzone-label">
                          <h4 class="fw-bold" style="color: #6c757d" *ngIf="!fileUploaded">Trascina o clicca qui per
                            inserire il file.</h4>
                          <h4 class="fw-bold" *ngIf="fileNameSelected && fileUploaded">{{fileNameSelected}}</h4>
                        </label>
                        <input type="file" id="fileInput" (change)="onFileSelected($event)" style="display: none"/>
                      </div>
                      <div class="row d-flex justify-content-end mt-4">
                        <div class="d-flex justify-content-end">
                          <button *ngIf="fileUploaded" (click)="changeFile()"
                                  class="btn remove-file-button primary-button no-border mx-3">
                            Sostituisci file
                          </button>
                          <button *ngIf="fileUploaded" (click)="removeFile()"
                                  class="btn remove-file-button primary-button no-border mx-3">
                            Rimuovi file
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button class="btn btn-outline-primary btn-sm primary-outline-button" type="button"
                              data-bs-dismiss="modal">
                        <span jhiTranslate="modale.annulla">Annulla</span>
                      </button>
                      <button class="btn btn-primary primary-button btn-sm" type="button" data-bs-dismiss="modal"
                              (click)="importUpdateAllegato()" [disabled]="!fileUploaded">
                        <span jhiTranslate="modale.conferma">Conferma</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <tr *ngIf="getArrayAllegati().length > 0">
                <th scope="col">Nome file</th>
                <th scope="col">Descrizione</th>
                <th scope="col" class="zero-width-td"></th>
                <th scope="col" class="zero-width-td"></th>
                <th scope="col" class="zero-width-td"></th>
                <th scope="col" class="zero-width-td"></th>
                <th scope="col"></th>
              </tr>
              </thead>
              <tbody *ngIf="getArrayAllegati().length > 0">
              <tr *ngFor="let allegato of getArrayAllegati().controls; index as i">
                <td><input [formControl]="convertToFormControl(allegato.get('titolo'))" placeholder="Titolo"
                           class="form-control fw-normal table-input" type="text" readonly></td>
                <td><input [formControl]="convertToFormControl(allegato.get('descrizione'))" placeholder="Descrizione"
                           class="form-control fw-normal table-input" type="text" readonly></td>
                <td class="zero-width-td"></td>
                <td class="zero-width-td"></td>
                <td class="zero-width-td"></td>
                <td class="zero-width-td"></td>
                <td>
                  <div class="d-flex justify-content-end">
                    <div
                            (click)="downloadAllegato(allegato.get('contenuto')?.value, allegato.get('titolo')?.value)" class="mx-2">
                      <svg class="icon icon-sm icon-primary c-pointer">
                        <use href="./content/svg/sprites.svg#it-download"></use>
                      </svg>
                    </div>
                    <div data-bs-toggle="modal" data-bs-target=".import-modal"
                            (click)="updateFile(allegato.get('id')?.value, allegato.get('titolo')?.value, allegato.get('contenuto')?.value, allegato.get('descrizione')?.value)">
                      <svg class="icon icon-sm icon-primary c-pointer">
                        <use href="./content/svg/sprites.svg#it-refresh"></use>
                      </svg>
                    </div>
                    <div class="mx-2"
                            (click)="deleteAllegato(allegato.get('id')?.value)">
                      <svg class="icon icon-sm icon-danger c-pointer">
                        <use href="./content/svg/sprites.svg#it-delete"></use>
                      </svg>
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </ng-container>
        <ng-container *ngIf="sezione === 'figlio'">
          <div class="accordion accordion-background-active" id="accordionFigli">
            <div class="accordion-item">
              <h2 class="accordion-header " id="headingFigli">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFigli" aria-controls="collapseFigli">
                  Figli
                </button>
              </h2>
            </div>
          </div>
          <div id="collapseFigli" class="accordion-collapse collapse show" data-bs-parent="#accordionExampleHa" role="region" aria-labelledby="headingFigli">
            <div class="accordion-body">
          <div class="callout note m-0 custom-callout">
            <div class="callout-title">
              <div class="d-flex justify-content-end">
                <div (click)="getArrayFigli().length === 10 ? '' : addFiglio()">
                  <svg class="icon icon-sm icon-primary c-pointer">
                    <use href="./content/svg/sprites.svg#it-plus"></use>
                  </svg>
                </div>
                <div (click)="this.getArrayFigli().pristine ? '' : modificaPersona('figlio')"
                     class="mx-2">
                  <svg class="icon icon-sm icon-success c-pointer">
                    <use href="./content/svg/sprites.svg#it-check"></use>
                  </svg>
                </div>
              </div>
            </div>
          <div class="table-responsive" style="overflow-x: hidden">
            <table class="table table-striped my-4">
              <thead>
              <tr>
                <th scope="col">Nome</th>
                <th scope="col">Cognome</th>
                <th scope="col">Codice Fiscale</th>
                <th scope="col">Data di nascita</th>
                <th scope="col">Luogo di nascita</th>
                <th scope="col">Sesso</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let figlio of getArrayFigli().controls; index as i">
                <td><input [formControl]="convertToFormControl(figlio.get('nome'))" placeholder="Nome"
                           class="form-control fw-normal table-input" type="text"></td>
                <td><input [formControl]="convertToFormControl(figlio.get('cognome'))" placeholder="Cognome"
                           class="form-control fw-normal table-input" type="text"></td>
                <td><input [formControl]="convertToFormControl(figlio.get('codice_fiscale'))"
                           placeholder="Codice Fiscale"
                           class="form-control fw-normal table-input" type="text"></td>
                <td><input [formControl]="convertToFormControl(figlio.get('data_di_nascita'))"
                           placeholder="Data di nascita"
                           class="form-control fw-normal table-input" type="date"></td>
                <td><input [formControl]="convertToFormControl(figlio.get('luogo_di_nascita'))"
                           placeholder="Luogo di nascita"
                           class="form-control fw-normal table-input" type="text"></td>
                <td>
                  <div class="bootstrap-select-wrapper">
                    <select [formControl]="convertToFormControl(figlio.get('sesso'))"
                            class="form-control fw-normal table-input" aria-label="sesso">
                      <option value=null> Scegli un'opzione </option>
                      <option value="F"> Femmina </option>
                      <option value="M"> Maschio </option>
                    </select>
                  </div>
                </td>
                  <td>
                    <div class="d-flex justify-content-end">
                    <div *ngIf="figlio.get('id')?.value === null"
                         (click)="getArrayFigli().length === 1 ? '' : removeFiglio(i)" class="me-2">
                      <svg class="icon icon-sm icon-danger c-pointer">
                        <use href="./content/svg/sprites.svg#it-delete"></use>
                      </svg>
                    </div>
                    <div
                      *ngIf="figlio.get('id')?.value !== null"
                             (click)="deleteFiglio(figlio.get('id')?.value, i)" class="me-2">
                      <svg class="icon icon-sm icon-danger c-pointer">
                        <use href="./content/svg/sprites.svg#it-delete"></use>
                      </svg>
                    </div>
                    </div>
                  </td>
              </tr>
              </tbody>
            </table>
          </div>
          </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="sezione === 'immobile'">
          <div class="accordion accordion-background-active" id="accordionImmobili">
            <div class="accordion-item">
              <h2 class="accordion-header " id="headingImmobili">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseImmobili" aria-controls="collapseImmobili">
                  Immobili
                </button>
              </h2>
            </div>
          </div>
          <div id="collapseImmobili" class="accordion-collapse collapse show" data-bs-parent="#accordionImmobili" role="region" aria-labelledby="headingImmobili">
            <div class="accordion-body">
              <div class="callout note m-0 custom-callout">
                <div class="callout-title">
                  <div class="d-flex justify-content-end">
                    <div (click)="getArrayImmobili().length === 10 ? '' : addImmobile()">
                      <svg class="icon icon-sm icon-primary c-pointer">
                        <use href="./content/svg/sprites.svg#it-plus"></use>
                      </svg>
                    </div>
                    <div (click)="this.getArrayImmobili().pristine ? '' : modificaImmobili()"
                         class="mx-2">
                      <svg class="icon icon-sm icon-success c-pointer">
                        <use href="./content/svg/sprites.svg#it-check"></use>
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="callout note m-0 custom-callout" *ngFor="let immobile of getArrayImmobili().controls; index as i">
                  <div class="callout-title">
                    <div class="d-flex justify-content-end">
                      <div
                        *ngIf="immobile.get('id')?.value !== null"
                        (click)="deleteImmobile(immobile.get('id')?.value, i)" class="me-2">
                        <svg class="icon icon-sm icon-danger c-pointer">
                          <use href="./content/svg/sprites.svg#it-delete"></use>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div class="card p-0">
                    <div class="card-body p-0">
                      <div class="row">
                        <div class="col-lg-3">
                          <label class="active">Via</label>
                          <input [formControl]="convertToFormControl(immobile.get('via'))" placeholder="Via"
                                 class="form-control fw-normal table-input" type="text">
                        </div>
                        <div class="col-lg-3">
                          <label class="active">Numero civico</label>
                          <input [formControl]="convertToFormControl(immobile.get('numero_civico'))" placeholder="Numero civico"
                                 class="form-control fw-normal table-input" type="text">
                        </div>
                        <div class="col-lg-3">
                          <label class="active">Interno</label>
                          <input [formControl]="convertToFormControl(immobile.get('interno'))"
                                 placeholder="Interno"
                                 class="form-control fw-normal table-input" type="text">
                        </div>
                        <div class="col-lg-3">
                          <label class="active">Piano</label>
                          <input [formControl]="convertToFormControl(immobile.get('piano'))"
                                 placeholder="Piano"
                                 class="form-control fw-normal table-input" type="text">
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-lg-3">
                          <label class="active">Città</label>
                          <input [formControl]="convertToFormControl(immobile.get('citta'))"
                                 placeholder="Città"
                                 class="form-control fw-normal table-input" type="text">
                        </div>
                        <div class="col-lg-3">
                          <label class="active">Provincia</label>
                          <input [formControl]="convertToFormControl(immobile.get('provincia'))"
                                 placeholder="Provincia"
                                 class="form-control fw-normal table-input" type="text">
                        </div>
                        <div class="col-lg-3">
                          <label class="active">Cap</label>
                          <input [formControl]="convertToFormControl(immobile.get('citta'))"
                                 placeholder="Città"
                                 class="form-control fw-normal table-input" type="text">
                        </div>
                        <div class="col-lg-3">
                          <label class="active">Nazione</label>
                          <input [formControl]="convertToFormControl(immobile.get('nazione'))"
                                 placeholder="Nazione"
                                 class="form-control fw-normal table-input" type="text">
                        </div>
                      </div>
                      <div class="row mt-3">
                        <div class="col-lg-3">
                          <label class="active">Sezione</label>
                          <input [formControl]="convertToFormControl(immobile.get('sezione'))"
                                 placeholder="Sezione"
                                 class="form-control fw-normal table-input" type="text">
                        </div>
                        <div class="col-lg-3">
                          <label class="active">Foglio</label>
                          <input [formControl]="convertToFormControl(immobile.get('foglio'))"
                                 placeholder="Foglio"
                                 class="form-control fw-normal table-input" type="number">
                        </div>
                        <div class="col-lg-3">
                          <label class="active">Numero</label>
                          <input [formControl]="convertToFormControl(immobile.get('numero'))"
                                 placeholder="Numero"
                                 class="form-control fw-normal table-input" type="text">
                        </div>
                        <div class="col-lg-3">
                          <label class="active">Subalterno</label>
                          <input [formControl]="convertToFormControl(immobile.get('subalterno'))"
                                 placeholder="Subalterno"
                                 class="form-control fw-normal table-input" type="text">
                        </div>
                      </div>
                      <div class="row mt-3">
                        <div class="col-lg-3">
                          <label class="active">Codice ateco</label>
                          <input [formControl]="convertToFormControl(immobile.get('codice_ateco'))"
                                 placeholder="Codice ateco"
                                 class="form-control fw-normal table-input" type="text">
                        </div>
                        <div class="col-lg-3">
                          <label class="active">Uso</label>
                          <div class="bootstrap-select-wrapper">
                            <select [formControl]="convertToFormControl(immobile.get('uso'))"
                                    class="form-control fw-normal table-input" aria-label="uso">
                              <option value="ABI">Abitazione</option>
                              <option value="BOX">Box / Garage</option>
                              <option value="PER">Pertinenza</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg-3">
                          <label class="active">
                            Categoria
                          </label>
                          <div class="bootstrap-select-wrapper">
                            <select [formControl]="convertToFormControl(immobile.get('categoria'))"
                                    class="form-control fw-normal table-input" aria-label="categoria">
                              <option value="A1"> A/1 </option>
                              <option value="A2"> A/2 </option>
                              <option value="A3"> A/3 </option>
                              <option value="A4"> A/4 </option>
                              <option value="A5"> A/5 </option>
                              <option value="A6"> A/6 </option>
                              <option value="A7"> A/7 </option>
                              <option value="A8"> A/8 </option>
                              <option value="A9"> A/9 </option>
                              <option value="A10"> A/10 </option>
                              <option value="B1"> B/1 </option>
                              <option value="B2"> B/2 </option>
                              <option value="B3"> B/3 </option>
                              <option value="B4"> B/4 </option>
                              <option value="B6"> B/5 </option>
                              <option value="B7"> B/6 </option>
                              <option value="B7"> B/7 </option>
                              <option value="B8"> B/8 </option>
                              <option value="C1"> C/1 </option>
                              <option value="C2"> C/2 </option>
                              <option value="C3"> C/3 </option>
                              <option value="C4"> C/4 </option>
                              <option value="C5"> C/5 </option>
                              <option value="C6"> C/6 </option>
                              <option value="C7"> C/7 </option>
                              <option value="D1"> D/1 </option>
                              <option value="D2"> D/2 </option>
                              <option value="D3"> D/3 </option>
                              <option value="D4"> D/4 </option>
                              <option value="D5"> D/5 </option>
                              <option value="D6"> D/6 </option>
                              <option value="D7"> D/7 </option>
                              <option value="D8"> D/8 </option>
                              <option value="D9"> D/9 </option>
                              <option value="D10"> D/10 </option>
                              <option value="D11"> D/11 </option>
                              <option value="D12"> D/12 </option>
                              <option value="E1"> E/1 </option>
                              <option value="E2"> E/2 </option>
                              <option value="E3"> E/3 </option>
                              <option value="E4"> E/4 </option>
                              <option value="E5"> E/5 </option>
                              <option value="E6"> E/6 </option>
                              <option value="E7"> E/7 </option>
                              <option value="E8"> E/8 </option>
                              <option value="E9"> E/9 </option>
                              <option value="F1"> F/1 </option>
                              <option value="F1"> F/2 </option>
                              <option value="F1"> F/3 </option>
                              <option value="F1"> F/4 </option>
                              <option value="F1"> F/5 </option>
                              <option value="T"> T </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="sezione === 'convivente'">
          <div class="accordion accordion-background-active" id="accordionConvivente">
            <div class="accordion-item">
              <h2 class="accordion-header " id="headingConvivente">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseConvivente" aria-controls="collapseConvivente">
                  Convivente
                </button>
              </h2>
            </div>
          </div>
          <div id="collapseConvivente" class="accordion-collapse collapse show" data-bs-parent="#accordionExampleHa" role="region" aria-labelledby="headingConiuge">
            <div class="accordion-body">
              <div class="callout note m-0 custom-callout">
                <div class="callout-title">
                  <div class="d-flex justify-content-end">
                    <div title="Aggiungi convivente" (click)="addConvivente()">
                      <svg class="icon icon-sm icon-primary c-pointer">
                        <use href="./content/svg/sprites.svg#it-plus"></use>
                      </svg>
                    </div>
                    <div (click)="this.getArrayConviventi().pristine ? '' : modificaPersona('convivente')"
                         class="mx-2">
                      <svg class="icon icon-sm icon-success c-pointer">
                        <use href="./content/svg/sprites.svg#it-check"></use>
                      </svg>
                    </div>
                  </div>
                </div>
          <div class="table-responsive" style="overflow-x: hidden">
            <table class="table table-striped my-4">
              <thead>
              <tr>
                <th scope="col">Nome</th>
                <th scope="col">Cognome</th>
                <th scope="col">Codice Fiscale</th>
                <th scope="col">Data di nascita</th>
                <th scope="col">Luogo di nascita</th>
                <th scope="col">Sesso</th>
              </thead>
              <tbody>
              <tr *ngFor="let convivente of getArrayConviventi().controls; index as i">
                <td><input [formControl]="convertToFormControl(convivente.get('nome'))" placeholder="Nome"
                           class="form-control fw-normal table-input" type="text"></td>
                <td><input [formControl]="convertToFormControl(convivente.get('cognome'))" placeholder="Cognome"
                           class="form-control fw-normal table-input" type="text"></td>
                <td><input [formControl]="convertToFormControl(convivente.get('codice_fiscale'))"
                           placeholder="Codice Fiscale"
                           class="form-control fw-normal table-input" type="text"></td>
                <td><input [formControl]="convertToFormControl(convivente.get('data_di_nascita'))"
                           placeholder="Data di nascita"
                           class="form-control fw-normal table-input" type="date"></td>
                <td><input [formControl]="convertToFormControl(convivente.get('luogo_di_nascita'))"
                           placeholder="Luogo di nascita"
                           class="form-control fw-normal table-input" type="text"></td>
                <td>
                  <select [formControl]="convertToFormControl(convivente.get('sesso'))"
                          class="form-control fw-normal table-input" aria-label="sesso">
                    <option value=null> Scegli un'opzione </option>
                    <option value="F"> Femmina </option>
                    <option value="M"> Maschio </option>
                  </select>
                </td>
                  <td>
                    <div class="d-flex justify-content-end">
                    <div
                            *ngIf="convivente.get('id')?.value === null"
                             (click)="getArrayConviventi().length === 1 ? '' : removeConvivente(i)" class="me-2">
                      <svg class="icon icon-sm icon-danger c-pointer">
                        <use href="./content/svg/sprites.svg#it-delete"></use>
                      </svg>
                    </div>
                    <div *ngIf="convivente.get('id')?.value !== null" (click)="deleteConvivente(convivente.get('id')?.value, i)" class="me-2">
                      <svg class="icon icon-sm icon-danger c-pointer">
                        <use href="./content/svg/sprites.svg#it-delete"></use>
                      </svg>
                    </div>
                    </div>
                  </td>
              </tr>
              </tbody>
            </table>
          </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="sezione === 'coniuge'">
          <div class="accordion accordion-background-active" id="accordionConiuge">
            <div class="accordion-item">
              <h2 class="accordion-header " id="headingConiuge">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseConiuge" aria-controls="collapseConiuge">
                  Coniuge
                </button>
              </h2>
            </div>
          </div>
          <div id="collapseConiuge" class="accordion-collapse collapse show" data-bs-parent="#accordionExampleHa" role="region" aria-labelledby="headingConiuge">
            <div class="accordion-body">
          <div class="callout note m-0 custom-callout">
            <div class="callout-title">
              <div (click)="modificaConiuge()"
                   class="mx-2">
                <svg class="icon icon-sm icon-success c-pointer">
                  <use href="./content/svg/sprites.svg#it-check"></use>
                </svg>
              </div>
            </div>
          <form [formGroup]="coniugeForm">
            <div class="table-responsive" style="overflow-x: hidden">
              <table class="table table-striped my-4">
                <thead>
                <tr>
                  <th scope="col">Nome</th>
                  <th scope="col">Cognome</th>
                  <th scope="col">Codice Fiscale</th>
                  <th scope="col">Data di nascita</th>
                  <th scope="col">Luogo di nascita</th>
                  <th scope="col">Sesso</th>
                </thead>
                <tbody>
                <tr>
                  <td><input formControlName="nome" placeholder="Nome"
                             class="form-control fw-normal table-input" type="text"></td>
                  <td><input formControlName="cognome" placeholder="Cognome"
                             class="form-control fw-normal table-input" type="text"></td>
                  <td><input formControlName="codice_fiscale"
                             placeholder="Codice Fiscale"
                             class="form-control fw-normal table-input" type="text"></td>
                  <td><input formControlName="data_di_nascita"
                             placeholder="Data di nascita"
                             class="form-control fw-normal table-input" type="date"></td>
                  <td><input formControlName="luogo_di_nascita"
                             placeholder="Luogo di nascita"
                             class="form-control fw-normal table-input" type="text"></td>
                  <td>
                    <select [formControl]="convertToFormControl(coniugeForm.get('sesso'))"
                            class="form-control fw-normal table-input" aria-label="sesso">
                      <option value=null> Scegli un'opzione </option>
                      <option value="F"> Femmina </option>
                      <option value="M"> Maschio </option>
                    </select>
                  </td>
                    <td>
                      <div class="d-flex justify-content-end">
                      <div (click)="deleteConiuge(coniugeForm.get('id')?.value)" class="me-2">
                        <svg class="icon icon-sm icon-danger c-pointer">
                          <use href="./content/svg/sprites.svg#it-delete"></use>
                        </svg>
                      </div>
                      </div>
                    </td>
                </tr>
                </tbody>
              </table>
            </div>
          </form>
          </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="sezione === 'residenza'">
          <form [formGroup]="residenzaForm">
            <div class="table-responsive" style="overflow-x: hidden">
              <table class="table table-striped my-4">
                <thead>
                <tr>
                  <td colspan="6" class="text-start table-header">
                    <h5 class="fw-bold mb-0">Residenza</h5>
                  </td>
                  <td colspan="6">
                    <div class="d-flex justify-content-end">
                    <div (click)="this.residenzaForm.pristine ? '' : modificaIndirizzo('residenza')"
                            class="me-2">
                      <svg class="icon icon-sm icon-success c-pointer">
                        <use href="./content/svg/sprites.svg#it-check"></use>
                      </svg>
                    </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="col">Via</th>
                  <th scope="col">Numero Civico</th>
                  <th scope="col">Interno</th>
                  <th scope="col">Piano</th>
                  <th scope="col">Città</th>
                  <th scope="col">Cap</th>
                  <th scope="col">Provincia</th>
                  <th scope="col">Nazione</th>
                  <th scope="col" class="zero-width-td"></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td><input formControlName="via" placeholder="Via..."
                             class="form-control fw-normal table-input" type="text"></td>
                  <td><input formControlName="numero_civico" placeholder="Numero Civico"
                             class="form-control fw-normal table-input" type="number"></td>
                  <td><input formControlName="interno" placeholder="Interno"
                             class="form-control fw-normal table-input" type="text"></td>
                  <td><input formControlName="piano" placeholder="Piano"
                             class="form-control fw-normal table-input" type="text"></td>
                  <td><input formControlName="citta" placeholder="Città"
                             class="form-control fw-normal table-input" type="text"></td>
                  <td><input formControlName="cap" placeholder="Cap"
                             class="form-control fw-normal table-input" type="number"></td>
                  <td><input formControlName="provincia" placeholder="Provincia"
                             class="form-control fw-normal table-input" type="text"></td>
                  <td><input formControlName="nazione" placeholder="Nazione"
                             class="form-control fw-normal table-input" type="text"></td>
                    <td>
                      <div class="d-flex justify-content-end">
                      <div (click)="deleteIndirizzo(residenzaForm.get('id')?.value, 'residenza')" class="me-2">
                        <svg class="icon icon-sm icon-danger c-pointer">
                          <use href="./content/svg/sprites.svg#it-delete"></use>
                        </svg>
                      </div>
                      </div>
                    </td>
                </tr>
                </tbody>
              </table>
            </div>
          </form>
        </ng-container>
        <ng-container *ngIf="sezione === 'domicilio'">
          <div class="accordion accordion-background-active" id="accordionDomicilio">
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingDomicilio">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseDomicilio" aria-controls="collapseDomicilio">
                  Domicilio
                </button>
              </h2>
            </div>
          </div>
          <div id="collapseDomicilio" class="accordion-collapse collapse show" data-bs-parent="#accordionDomicilio" role="region" aria-labelledby="headingDomicilio">
            <div class="accordion-body">
              <div class="callout note m-0 custom-callout">
                <div class="callout-title">
                  <div
                    (click)="this.domicilioForm.pristine ? '' : modificaIndirizzo('domicilio')" class="me-2">
                    <svg class="icon icon-sm icon-success c-pointer">
                      <use href="./content/svg/sprites.svg#it-check"></use>
                    </svg>
                  </div>
                </div>
          <form [formGroup]="domicilioForm">
            <div class="table-responsive" style="overflow-x: hidden">
              <table class="table table-striped my-4">
                <thead>
                <tr>
                  <th scope="col">Via</th>
                  <th scope="col">Numero Civico</th>
                  <th scope="col">Interno</th>
                  <th scope="col">Piano</th>
                  <th scope="col">Città</th>
                  <th scope="col">Cap</th>
                  <th scope="col">Provincia</th>
                  <th scope="col">Nazione</th>
                  <th scope="col" class="zero-width-td"></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td><input formControlName="via" placeholder="Via..."
                             class="form-control fw-normal table-input" type="text"></td>
                  <td><input formControlName="numero_civico" placeholder="Numero Civico"
                             class="form-control fw-normal table-input" type="number"></td>
                  <td><input formControlName="interno" placeholder="Interno"
                             class="form-control fw-normal table-input" type="text"></td>
                  <td><input formControlName="piano" placeholder="Piano"
                             class="form-control fw-normal table-input" type="text"></td>
                  <td><input formControlName="citta" placeholder="Città"
                             class="form-control fw-normal table-input" type="text"></td>
                  <td><input formControlName="cap" placeholder="Cap"
                             class="form-control fw-normal table-input" type="number"></td>
                  <td><input formControlName="provincia" placeholder="Provincia"
                             class="form-control fw-normal table-input" type="text"></td>
                  <td><input formControlName="nazione" placeholder="Nazione"
                             class="form-control fw-normal table-input" type="text"></td>
                    <td>
                      <div class="d-flex justify-content-end">
                      <div (click)="deleteIndirizzo(domicilioForm.get('id')?.value, 'domicilio')" class="me-2">
                        <svg class="icon icon-sm icon-danger c-pointer">
                          <use href="./content/svg/sprites.svg#it-delete"></use>
                        </svg>
                      </div>
                      </div>
                    </td>
                </tr>
                </tbody>
              </table>
            </div>
          </form>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="sezione === 'coordinate_bancarie'">
          <div class="accordion accordion-background-active" id="accordionCoordinate">
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingCoordinate">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseCoordinate" aria-controls="collapseCoordinate">
                  Coordinate bancarie
                </button>
              </h2>
            </div>
          </div>
          <div id="collapseCoordinate" class="accordion-collapse collapse show" data-bs-parent="#accordionCoordinate" role="region" aria-labelledby="headingCoordinate">
            <div class="accordion-body">
              <div class="callout note m-0 custom-callout">
                <div class="callout-title">
                  <div (click)="this.coordinateBancarieForm.pristine ? '' : modificaCoordinateBancarie()">
                    <svg class="icon icon-sm icon-success c-pointer">
                      <use href="./content/svg/sprites.svg#it-check"></use>
                    </svg>
                  </div>
                </div>
          <form [formGroup]="coordinateBancarieForm">
            <div class="table-responsive" style="overflow-x: hidden">
              <table class="table table-striped my-4">
                <thead>
                <tr>
                  <th scope="col">Nome Intestatario</th>
                  <th scope="col">Cognome Intestatario</th>
                  <th scope="col" class="zero-width-td"></th>
                  <th scope="col" class="zero-width-td"></th>
                  <th scope="col">IBAN</th>
                  <th scope="col">Swift</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td><input formControlName="nomeIntestatario" placeholder="Nome Intestatario"
                             class="form-control fw-normal table-input" type="text"></td>
                  <td><input formControlName="cognomeIntestatario" placeholder="Cognome Intestatario"
                             class="form-control fw-normal table-input" type="text"></td>
                  <td class="zero-width-td"></td>
                  <td class="zero-width-td"></td>
                  <td><input formControlName="iban" placeholder="IBAN"
                             class="form-control fw-normal table-input" type="text"></td>
                  <td><input formControlName="swift" placeholder="Swift"
                             class="form-control fw-normal table-input" type="text"></td>
                    <td>
                      <div (click)="deleteCoordinate(coordinateBancarieForm.get('id')?.value)">
                        <svg class="icon icon-sm icon-danger c-pointer">
                          <use href="./content/svg/sprites.svg#it-delete"></use>
                        </svg>
                      </div>
                    </td>

                </tr>
                </tbody>
              </table>
            </div>
          </form>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="sezione === 'isee'">
          <div class="accordion accordion-background-active" id="accordionIsee">
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingIsee">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseIsee" aria-controls="collapseIsee">
                  ISEE
                </button>
              </h2>
            </div>
          </div>
          <div id="collapseIsee" class="accordion-collapse collapse show" data-bs-parent="#accordionIsee" role="region" aria-labelledby="headingIsee">
            <div class="accordion-body">
              <div class="callout note m-0 custom-callout">
                <div class="callout-title">
                  <div (click)="this.iseeForm.pristine ? '' : modificaISEE()"
                       class="me-2">
                    <svg class="icon icon-sm icon-success c-pointer">
                      <use href="./content/svg/sprites.svg#it-check"></use>
                    </svg>
                  </div>
                </div>
          <form [formGroup]="iseeForm">
            <div class="table-responsive" style="overflow-x: hidden">
              <table class="table table-striped my-4">
                <thead>
                <tr>
                  <th scope="col">Valore</th>
                  <th scope="col" class="zero-width-td"></th>
                  <th scope="col" class="zero-width-td"></th>
                  <th scope="col" class="zero-width-td"></th>
                  <th scope="col" class="zero-width-td"></th>
                  <th scope="col" class="zero-width-td"></th>
                  <th scope="col" class="zero-width-td"></th>
                  <th scope="col">Data Scadenza</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td><input formControlName="imValore" placeholder="Valore"
                             class="form-control fw-normal table-input" type="number"></td>
                  <th scope="col" class="zero-width-td"></th>
                  <th scope="col" class="zero-width-td"></th>
                  <th scope="col" class="zero-width-td"></th>
                  <th scope="col" class="zero-width-td"></th>
                  <th scope="col" class="zero-width-td"></th>
                  <th scope="col" class="zero-width-td"></th>
                  <td><input formControlName="dtScadenza" placeholder="Data Scadenza"
                             class="form-control fw-normal table-input" type="date"></td>
                    <td>
                      <div class="d-flex justify-content-end">
                      <div (click)="deleteISEE(iseeForm.get('id')?.value)" class="me-2">
                        <svg class="icon icon-sm icon-danger c-pointer">
                          <use href="./content/svg/sprites.svg#it-delete"></use>
                        </svg>
                      </div>
                      </div>
                    </td>
                </tr>
                </tbody>
              </table>
            </div>
          </form>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<input type="hidden" #_MD_VISURE data-bs-toggle="modal" data-bs-target="#modaleVisure" >
<!-- Modale salva preferenze -->
<div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="modalInitVis" data-bs-keyboard="false" data-bs-backdrop="static" aria-hidden="true" id="modaleVisure">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title h5" id="modalInitVis">Aggiorna dati da visure anagrafiche</h2>
      </div>
      <div class="modal-body">
        <div>
          <p>Vuoi aggiornare i dati dei tuoi preferiti effettuando una visura anagrafica dai sistemi comunali? L'aggiornamento potrebbe comportare la perdita dei dati dei preferiti attualmente salvati.<br>Se il soggetto che sta effettuando la visura non é l'intestatario del nucleo familiare, sia i figli che il coniuge verranno inseriti come conviventi.<br> É comunque possibile modificare, aggiungere o eliminare i dati della visura attraverso le funzionalità di gestione dei preferiti. </p>
        </div>
      </div>
      <div class="modal-footer">
        <div class="d-flex flex-row">
          <button class="btn btn-xs btn-success" (click)="aggiornaPrefDaVis()">Aggiorna</button>
          <button class="ms-2 btn btn-xs btn-outline-success" (click)="openMdPreferiti()">Mantieni dati attuali</button>
        </div>
      </div>
    </div>
  </div>
</div>
